module.exports = "/assets/data/b8e491fa64926f199e6fbab9d78f7755-WC2A.data.json";